import React from 'react';
import { Region } from '@enonic/react-components';
import type { RegularLayoutProps } from './regular-layout.d';
import CountyMenu from '../../../react4xp/components/CountyMenu';
import Campaign from '../../../react4xp/components/Campaign';
import RichTextSection from '../../../react4xp/components/RichTextSection';

function RegularLayout({ 
  body, 
  regions,
  currentCountyLabel,
  currentCountyHref,
  currentCountyTarget,
  countySubMenu,
  countyMenu,
  campaign,
  showCampaign
}: RegularLayoutProps) {
  // Render CountyMenu if county data exists
  const hasCountyData = currentCountyLabel && currentCountyHref && currentCountyTarget && countySubMenu && countyMenu

  return (
    <>
      {hasCountyData && (
        <CountyMenu
          currentCountyLabel={currentCountyLabel}
          currentCountyHref={currentCountyHref}
          currentCountyTarget={currentCountyTarget}
          countyItems={countySubMenu}
          menuItems={countyMenu}
        />
      )}

      {showCampaign && campaign && (
        <Campaign
          view='with-image'
          background='dark'
          heading={campaign.heading}
          description={campaign.description}
          header_image={campaign.header_image}
        />
      )}

      <RichTextSection content={body || ''} />

      <Region name="content" regionData={regions.content} />
    </>
  );
}

export default (props) => <RegularLayout {...props} />;
